import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

export { default as Text } from './Text.vue'

export const textVariants = cva(
  '',
  {
    variants: {
      size: {
        xxl: 'text-3xl font-bold',
        xl: 'text-2xl font-semibold',
        lg: 'text-xl font-semibold',
        md: 'text-base font-semibold',
        base: 'text-base font-medium',
        sm: 'text-sm font-medium',
        xs: 'text-xs font-normal',
      },
    },
    defaultVariants: {
      size: 'base',
    },
  },
)

export type TextVariants = VariantProps<typeof textVariants>
